import { Action, createReducer, on } from '@ngrx/store';

import { ModelState } from '@personal-area/global/state';

import { Country } from '../../models/country';
import {
  GetCountries,
  GetCountriesFail,
  GetCountriesSuccess,
  SetCountriesLoading,
} from '../actions/countries';

export interface CountriesState extends ModelState {
  countries: Country[];
}

const initialState: CountriesState = {
  countries: [],
  isLoading: false,
  isLoaded: false,
};

const _reducer = createReducer(
  initialState,
  on(GetCountries, (state, { isForce }) => {
    return {
      ...state,
      isLoaded: isForce ? false : state.isLoaded,
    };
  }),
  on(GetCountriesSuccess, (state, { countries }) => {
    return {
      ...state,
      countries,
      isLoading: false,
      isLoaded: true,
    };
  }),
  on(GetCountriesFail, (state) => {
    return {
      ...state,
      isLoading: false,
    };
  }),
  on(SetCountriesLoading, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
);

export const countriesReducer = (
  state: CountriesState | undefined,
  action: Action,
) => _reducer(state, action);
